(function() {
    'use strict';

    const API_BASE = window.location.origin;
    const SESSION_KEY = 'goszemlya_analytics_session';

    function getAuthToken() {
        try { return localStorage.getItem('goszemlya_web_token'); } catch (e) { return null; }
    }

    function getTgInitData() {
        if (window.Telegram && Telegram.WebApp) {
            return Telegram.WebApp.initData || '';
        }
        return '';
    }

    function getHeaders() {
        const headers = { 'Content-Type': 'application/json' };
        const tgInitData = getTgInitData();
        if (tgInitData) {
            headers['Authorization'] = 'tma ' + tgInitData;
            return headers;
        }
        const token = getAuthToken();
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        return headers;
    }

    function parseUtm() {
        const params = new URLSearchParams(window.location.search);
        return {
            utmSource: params.get('utm_source') || undefined,
            utmMedium: params.get('utm_medium') || undefined,
            utmCampaign: params.get('utm_campaign') || undefined,
        };
    }

    function parseDeviceInfo() {
        const ua = navigator.userAgent.toLowerCase();
        const isMobile = /mobile|android|iphone|ipad|ipod/.test(ua);
        const isTablet = /ipad|tablet/.test(ua);
        const deviceType = isTablet ? 'tablet' : (isMobile ? 'mobile' : 'desktop');

        let os = 'unknown';
        if (/windows/.test(ua)) os = 'Windows';
        else if (/macintosh|mac os/.test(ua)) os = 'macOS';
        else if (/linux/.test(ua)) os = 'Linux';
        else if (/android/.test(ua)) os = 'Android';
        else if (/iphone|ipad|ipod/.test(ua)) os = 'iOS';

        let browser = 'unknown';
        if (/edg/.test(ua)) browser = 'Edge';
        else if (/opr|opera/.test(ua)) browser = 'Opera';
        else if (/firefox/.test(ua)) browser = 'Firefox';
        else if (/safari/.test(ua) && !/chrome/.test(ua)) browser = 'Safari';
        else if (/chrome/.test(ua)) browser = 'Chrome';

        return {
            deviceType,
            os,
            browser,
            screenSize: window.screen.width + 'x' + window.screen.height,
        };
    }

    async function api(path, body) {
        try {
            return await fetch(API_BASE + path, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(body),
            });
        } catch (e) {
            // ignore network errors
            return null;
        }
    }

    function beacon(path, body) {
        try {
            const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
            navigator.sendBeacon(API_BASE + path, blob);
        } catch (e) {
            // ignore
        }
    }

    async function startSession() {
        const deviceInfo = parseDeviceInfo();
        const utm = parseUtm();
        const source = window.Telegram && Telegram.WebApp ? 'miniapp' : 'web';
        const res = await api('/api/analytics/session-start', {
            source,
            entryPath: window.location.pathname + window.location.search,
            referrer: document.referrer || undefined,
            ...utm,
            ...deviceInfo,
        });
        if (res && res.ok) {
            const data = await res.json();
            if (data.sessionId) {
                try { sessionStorage.setItem(SESSION_KEY, data.sessionId); } catch (e) {}
                await detectBookmark(data.sessionId);
            }
        }
    }

    let sessionEnded = false;
    function endSession() {
        if (sessionEnded) return;
        const sessionId = sessionStorage.getItem(SESSION_KEY);
        if (!sessionId) return;
        sessionEnded = true;
        beacon('/api/analytics/session-end', { sessionId });
        try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
    }

    async function trackEvent(eventType, eventData) {
        const sessionId = sessionStorage.getItem(SESSION_KEY);
        if (!sessionId) return;
        await api('/api/analytics/event', { sessionId, eventType, eventData });
    }

    async function detectBookmark(sessionId) {
        let likely = false;
        if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true) {
            likely = true;
        }
        let directVisits = 0;
        const referrer = document.referrer || '';
        let isDirect = !referrer;
        if (referrer) {
            try {
                isDirect = new URL(referrer).hostname !== window.location.hostname;
            } catch (e) {
                isDirect = true;
            }
        }
        if (isDirect) {
            directVisits = parseInt(localStorage.getItem('goszemlya_direct_visits') || '0', 10) + 1;
            try { localStorage.setItem('goszemlya_direct_visits', String(directVisits)); } catch (e) {}
        }
        if (isDirect && directVisits >= 3) {
            likely = true;
        }
        if (likely) {
            await trackEvent('bookmark_detected', { value: 'likely' });
        }
    }

    const BANNER_LAST_SHOWN_KEY = 'goszemlya_bookmark_banner_last_shown';
    const BANNER_DAY_MS = 24 * 60 * 60 * 1000;

    function isAuthenticated() {
        if (typeof window.goszemlyaAuth === 'object' && window.goszemlyaAuth !== null && typeof window.goszemlyaAuth.isAuthenticated === 'function') {
            return window.goszemlyaAuth.isAuthenticated();
        }
        try {
            return Boolean(localStorage.getItem('goszemlya_web_token'));
        } catch (e) {
            return false;
        }
    }

    function shouldShowBookmarkBanner() {
        if (isAuthenticated()) return false;
        try {
            const lastShown = localStorage.getItem(BANNER_LAST_SHOWN_KEY);
            if (!lastShown) return true;
            return (Date.now() - parseInt(lastShown, 10)) >= BANNER_DAY_MS;
        } catch (e) {
            return false;
        }
    }

    function showBookmarkBanner() {
        if (!shouldShowBookmarkBanner()) return;

        const existing = document.getElementById('bookmark-banner');
        if (existing) return;

        const banner = document.createElement('div');
        banner.id = 'bookmark-banner';
        banner.innerHTML =
            '<span style="white-space:nowrap;">Нажми <strong>CTRL+D</strong> и добавь сайт в закладки</span>' +
            '<button id="bookmark-banner-close" aria-label="Закрыть" style="background:none;border:none;color:#fff;font-size:18px;line-height:1;cursor:pointer;padding:4px;margin:-4px -8px -4px 4px;">×</button>';
        banner.style.cssText =
            'position:fixed;' +
            'bottom:20px;' +
            'left:50%;' +
            'transform:translateX(-50%);' +
            'background:#1a1a2e;' +
            'color:#fff;' +
            'padding:12px 18px;' +
            'border-radius:12px;' +
            'box-shadow:0 4px 20px rgba(0,0,0,0.3);' +
            'z-index:10000;' +
            'font-size:14px;' +
            'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;' +
            'display:flex;' +
            'align-items:center;' +
            'gap:12px;' +
            'max-width:calc(100vw - 32px);';

        document.body.appendChild(banner);

        try {
            localStorage.setItem(BANNER_LAST_SHOWN_KEY, String(Date.now()));
        } catch (e) {}

        document.getElementById('bookmark-banner-close').addEventListener('click', function() {
            banner.remove();
        });
    }

    window.addEventListener('auth:change', function(event) {
        if (event.detail && event.detail.authenticated) {
            const banner = document.getElementById('bookmark-banner');
            if (banner) banner.remove();
        }
    });

    // ── B-фаза: отправка Web Vitals и таймингов ──────────────────
    const PERF_ENDPOINT = '/api/client-metrics';
    const perfDeviceType = (function(){ try { return parseDeviceInfo().deviceType; } catch(e){ return 'unknown'; } })();
    const perfQueue = [];
    let vitalsBound = false;

    function perfQueuePush(metric, value, meta) {
        if (typeof value !== 'number' || !isFinite(value) || value < 0) return;
        const item = { metric: metric, value: Math.min(value, 600), url: window.location.pathname };
        if (!item.meta) item.meta = {};
        if (typeof perfDeviceType === 'string') item.meta.device = perfDeviceType;
        if (meta && typeof meta === 'object') Object.assign(item.meta, meta);
        perfQueue.push(item);
        if (perfQueue.length >= 8) flushPerf();
    }

    function flushPerf() {
        if (!perfQueue.length) return;
        const items = perfQueue.splice(0, 20);
        const body = JSON.stringify({ items: items });
        try {
            const blob = new Blob([body], { type: 'application/json' });
            if (navigator.sendBeacon && navigator.sendBeacon(PERF_ENDPOINT, blob)) return;
            fetch(PERF_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
        } catch (e) {}
    }

    function bindVitals() {
        if (vitalsBound || !window.webVitals) return;
        vitalsBound = true;
        const wv = window.webVitals;
        const report = function (m) {
            let meta = null;
            const a = m.attribution;
            if (a) {
                meta = {};
                if (a.element) meta.element = String(a.element).slice(0, 160);
                if (a.largestShiftTarget) meta.target = String(a.largestShiftTarget).slice(0, 160);
                if (a.loadState) meta.loadState = a.loadState;
                if (a.eventTime) meta.eventTime = Math.round(a.eventTime);
                if (!meta.element && !meta.target && !meta.loadState) meta = null;
            }
            perfQueuePush(String(m.name).toLowerCase(), m.value, meta);
        };
        [wv.onLCP, wv.onFCP, wv.onTTFB, wv.onINP, wv.onCLS].forEach(function (fn) {
            try { fn(report); } catch (e) {}
        });
    }

    function initPerfSender() {
        bindVitals();
        setTimeout(function () {
            try {
                if (!vitalsBound) {
                    const nav = performance.getEntriesByType('navigation')[0];
                    if (nav && nav.responseStart > 0) perfQueuePush('ttfb', nav.responseStart / 1000);
                }
            } catch (e) {}
            flushPerf();
        }, 8000);
        setInterval(flushPerf, 30000);
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'hidden') flushPerf();
        });
    }
    initPerfSender();

    window.goszemlyaAnalytics = {
        trackEvent,
        startSession,
        endSession,
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startSession);
        document.addEventListener('DOMContentLoaded', showBookmarkBanner);
    } else {
        startSession();
        showBookmarkBanner();
    }

    window.addEventListener('pagehide', endSession);
    window.addEventListener('beforeunload', endSession);
})();
